var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvening(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "#5A3B84",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.3268 51.1439C32.7489 51.1439 32.1676 51.1203 31.5847 51.0713C21.4198 50.2315 13.1421 41.9285 12.3294 31.7585C12.0185 27.9387 12.7524 24.1062 14.4525 20.6715C16.1526 17.2368 18.7549 14.3291 21.9807 12.2599C22.384 11.9988 22.8532 11.8577 23.3336 11.8529C23.814 11.8481 24.2859 11.9799 24.6943 12.2329C25.529 12.7499 25.9818 13.6758 25.8771 14.6508C25.5746 17.4539 25.9632 20.2266 27.0294 22.8929C29.4862 29.028 34.9505 33.3265 41.2884 34.1122C44.3309 34.4993 47.4217 34.0858 50.2554 32.9125C50.6929 32.7284 51.174 32.6736 51.6418 32.7544C52.1095 32.8353 52.5443 33.0485 52.8946 33.3688C53.2552 33.6895 53.5167 34.1065 53.6484 34.5707C53.7801 35.0349 53.7765 35.5271 53.6381 35.9894C50.9921 44.9936 42.6165 51.1439 33.3268 51.1439ZM22.4014 16.1055C20.1019 17.9178 18.2864 20.2706 17.1166 22.9546C15.9468 25.6385 15.4591 28.5701 15.6969 31.4882C16.3795 40.0277 23.3308 46.9992 31.8635 47.7038C39.6596 48.3678 46.9589 43.777 49.833 36.6568C46.9393 37.5652 43.8841 37.8412 40.8744 37.4662C33.3149 36.5301 26.8081 31.429 23.8934 24.15C22.8592 21.5964 22.3517 18.8602 22.4014 16.1055Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvening);
export default __webpack_public_path__ + "static/media/evening.419aaa39122ae4a78dc1851328ab7b02.svg";
export { ForwardRef as ReactComponent };